import { DESKTOP_MAX_WIDTH, DESKTOP_MIN_HEIGHT, MOBILE_WIDTH, MOBILE_MIN_HEIGHT, DESKTOP_DEFAULT_HEIGHT, MOBILE_DEFAULT_HEIGHT } from 'crazyEditor/core/constants/editorConstants';
import PageElementMetaData from './PageElementMetaData';
import _ from 'lodash';

const presets = {
  desktop: [
    {
      type: PageElementMetaData.type,
      id: PageElementMetaData.id,
      compProps: {
        backgroundColor: '#fff',
        backgroundImage: null,
        fontFamily: 'Open Sans',
        zIndex: -1000,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#cdcccb'
      },
      hidden: false,
      layout: {
        x: 0,
        y: 0,
        width: DESKTOP_MAX_WIDTH,
        height: DESKTOP_DEFAULT_HEIGHT
      },
    }
  ],
  mobile: [
    {
      type: PageElementMetaData.type,
      id: PageElementMetaData.id,
      desktopId: PageElementMetaData.id,
      compProps: {
        fontFamily: 'Open Sans',
        zIndex: -1000
      },
      hidden: false,
      layout: {
        x: 0,
        y: 0,
        width: MOBILE_WIDTH,
        height: MOBILE_DEFAULT_HEIGHT
      }
    }
  ]
};

export default presets;
